import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import SmartPersonalizationPage from './pages/features/SmartPersonalizationPage';
import FlexiblePricingPage from './pages/features/FlexiblePricingPage';
import EasyToUsePage from './pages/features/EasyToUsePage';
import GlobalReachPage from './pages/features/GlobalReachPage';
import ProductPage from './pages/ProductPage';
import ProductDetailsPage from './pages/ProductDetailsPage';
import SolutionsPage from './pages/SolutionsPage';
import PricingPage from './pages/PricingPage';
import ResourcesPage from './pages/ResourcesPage';
import MediaWorldPage from './pages/MediaWorldPage';
import AuthCallback from './pages/AuthCallback';
import CookieBanner from './components/common/CookieBanner';

function App() {
  const [showCookieBanner, setShowCookieBanner] = useState(true);

  const handleAcceptCookies = () => {
    setShowCookieBanner(false);
  };

  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/features/smart-personalization" element={<SmartPersonalizationPage />} />
            <Route path="/features/flexible-pricing" element={<FlexiblePricingPage />} />
            <Route path="/features/easy-to-use" element={<EasyToUsePage />} />
            <Route path="/features/global-reach" element={<GlobalReachPage />} />
            <Route path="/product" element={<ProductDetailsPage />} />
            <Route path="/solutions" element={<SolutionsPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/media-world" element={<MediaWorldPage />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
          </Routes>
        </main>
        <Footer />
        {showCookieBanner && (
          <CookieBanner 
            onAccept={handleAcceptCookies} 
            onLearnMore={() => window.open('#privacy-policy', '_blank')}
          />
        )}
      </div>
    </Router>
  );
}

export default App;